'use strict';

export default class DataItem {
  constructor(data = undefined) {
    this.data = data;
  }

  isActive() {
    return true;
  }

  export() {
    return this.data;
  }
}



// WEBPACK FOOTER //
// ./data-items/data-item.js